/** True when the event target is a text-editing surface — an <input>,
 *  <textarea>, <select>, or a contenteditable element — so a global
 *  Delete/Backspace handler can bail and leave keystrokes to the field. */
export function isEditableTarget(el: EventTarget | null): boolean {
  if (!el || !(el instanceof HTMLElement)) return false;
  const tag = el.tagName;
  if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return true;
  // `isContentEditable` is the computed truth in real browsers; fall back to
  // the attribute for environments (jsdom) that don't compute it.
  if (el.isContentEditable) return true;
  const attr = el.getAttribute('contenteditable');
  return attr === '' || attr === 'true' || attr === 'plaintext-only';
}
